<template>
  <div>
    <div
      class="image-title-container"
      v-for="image in images"
      :key="image.uri"
      @click="$emit('select-image', image)"
    >
      <font-awesome-icon
        :icon="`fa-solid ${image.kind == 'MAP' ? 'fa-map-location-dot' : 'fa-image'}`"
        class="image-icon"
      />
      <span class="image-title">
        {{ image.title }}
      </span>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'MediaList',
    props: {
      images: {
        type: Array,
      },
    },
    emits: ['select-image'],
  };
</script>

<style type="text/css" scoped>
  .image-title-container {
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    cursor: pointer;
  }
  .image-title {
    margin-inline-start: 0.5em;
    font-style: italic;
  }
</style>
